import React from "react";
import { TableRow } from "@mui/material";

import "./styles.scss";
import { ParentProps } from "../../types";

const classNameBase = "scd-table-row";

export default function Row(props: ParentProps): React.ReactElement {
  return (
    <TableRow
      tabIndex={-1}
      classes={{
        root: `${classNameBase}-root`,
        selected: `${classNameBase}-selected`,
        hover: `${classNameBase}-hover`,
        head: `${classNameBase}-head`,
        footer: `${classNameBase}-footer`,
      }}
    >
      {props.children}
    </TableRow>
  );
}
